//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import './index.less'
import BScroll from 'better-scroll'
import MouseWheel from '@better-scroll/mouse-wheel'

BScroll.use(MouseWheel)
import {
  getUserInfo,
  getUserNewInfo,
  isApp,
  shareFun,
  toggleTopbar,
  switchNavColor,
  callApp,
  controlTopButton,
  logEventStatistics,
  pageViewStatistics,
  system
} from '@/util/const'
import {setAuthorization, setHeader} from '@/axios/userInfo'

export default {
  name: "index",
  computed: {},
  data() {
    return {
      URL: process.env.NODE_ENV === 'development' ? `http://47.57.156.216` : `${window.location.origin}`,
      phone: '',
      userId: '',
      isMask: false,
      isToast: false,
      isToastUrl: '',
      inApp: true,
      isTips: true,
      isShare: true,
      tabList: [
        {title: this.$t('everyDaySpecial.one'), day: 1},
        {title: this.$t('everyDaySpecial.two'), day: 1},
        {title: this.$t('everyDaySpecial.three'), day: 1},
        {title: this.$t('everyDaySpecial.four'), day: 1},
        {title: this.$t('everyDaySpecial.five'), day: 1},
      ],
      lang: '',
      today: '',
      tabIndex: '',
      // 1：已结束  2：进行中 3：未开始
      flag: null,
      bannerList: [],
      background: '',
      word: '',
      startTime: '',
      endTime: '',
      H: '00',
      M: '00',
      S: '00',
      timer: null,
      couponList: [],
      userKillList: [],
      productList: [],
      recommendedList: [],
      productTag: [],
      slowList: [],
      activityList: [],
      drag: {
        isDrag: false,
        oldLeft: 0,
        oldTop: 0,
        newLeft: 0,
        newTop: 0,
      },
      isTouch: false,
      isCheck: false,
      authorization: '',
      scroll: {
        scrollX: 0,
        scrollY: 0,
        scrollContent: null,
        scrollTab: null,
        list: [],
        scrollIndex: 0,
        isShow: false,
      }
    }
  },
  methods: {
    toastJump() {
      this.isToast = false
      window.location.href = this.isToastUrl
    },
    goShop() {
      let url = `${this.URL}/mylink`
      window.location.href = `${url}/#/integral/points?hideNavigationBar=true`
    },
    // 数据
    numFix(num) {
      return num.toFixed(0)
    },
    stringFix(num) {
      if (parseInt(num) > 999) {
        return '999+'
      } else {
        return num
      }
    },
    // 展开收起
    toogle(target, index) {
      let list = document.getElementById(target + 'List' + index)
      let btn = document.getElementById(target + 'Btn' + index)
      if (list.className === 'list toogleHide') {
        list.className = 'list'
        btn.getElementsByTagName('p')[0].getElementsByTagName('span')[0].innerHTML = this.$t('everyDaySpecial.index.t33')
        btn.getElementsByTagName('p')[0].getElementsByTagName('i')[0].className = 'hide'
      } else {
        list.className = 'list toogleHide'
        btn.getElementsByTagName('p')[0].getElementsByTagName('span')[0].innerHTML = this.$t('everyDaySpecial.index.t32')
        btn.getElementsByTagName('p')[0].getElementsByTagName('i')[0].className = ''
      }
    },
    toogle2(target, index) {
      let list = document.getElementById(target + 'List' + index)
      let btn = document.getElementById(target + 'Btn' + index)
      if (list.className === 'list toogleHideProduct') {
        list.className = 'list'
        btn.getElementsByTagName('p')[0].getElementsByTagName('span')[0].innerHTML = this.$t('everyDaySpecial.index.t33')
        btn.getElementsByTagName('p')[0].getElementsByTagName('i')[0].className = 'hide'
      } else {
        list.className = 'list toogleHideProduct'
        btn.getElementsByTagName('p')[0].getElementsByTagName('span')[0].innerHTML = this.$t('everyDaySpecial.index.t32')
        btn.getElementsByTagName('p')[0].getElementsByTagName('i')[0].className = ''
      }
    },
    // 错误提示
    errorTips(code) {
      let str = ''
      switch (code) {
        case 10001:
          str = '错误'
          break;
        case 10002:
          str = '已存在'
          break;
        case 10003:
          str = '不存在'
          break;
        case 10004:
          str = '数据其他地方有引用'
          break;
        case 10005:
          str = '文件为空'
          break;
        case 10008:
          str = '用户不存在'
          break;
        case 10009:
          str = '参数错误'
          break;
        case 11001:
          str = this.$t('everyDaySpecial.tips.R1')
          break;
        case 11002:
          str = '数据其他地方有引用'
          break;
        case 11003:
          str = this.$t('everyDaySpecial.tips.R3')
          break;
        case 11004:
          str = this.$t('everyDaySpecial.tips.R2')
          break;
        case 13001:
          str = this.$t('everyDaySpecial.tips.R5')
          break;
        case 14001:
          str = this.$t('everyDaySpecial.tips.R6')
          break;
        case 14002:
          str = this.$t('everyDaySpecial.tips.R6')
          break;
        case 14003:
          str = this.$t('everyDaySpecial.tips.R7')
          break;
        case 14004:
          str = this.$t('everyDaySpecial.tips.R8')
          break;
        case 14005:
          str = this.$t('everyDaySpecial.tips.R9')
          break;
        case 14006:
          str = this.$t('everyDaySpecial.tips.R9')
          break;
        case 14007:
          str = this.$t('everyDaySpecial.tips.R9')
          break;
        case 14008:
          str = this.$t('everyDaySpecial.tips.R9')
          break;
        case 14009:
          str = this.$t('everyDaySpecial.tips.R9')
          break;
        case 14010:
          str = this.$t('everyDaySpecial.tips.R10')
          break;
        case 14010:
          str = this.$t('everyDaySpecial.tips.R9')
          break;
        default:
          str = this.$t('everyDaySpecial.tips.R11');
      }
      this.$toast({msg: str, time: 2000})
    },
    // 点击
    domDown(e) {
      e.preventDefault()
      let dom = document.getElementById('shareBox')
      this.drag.isDrag = true
      this.drag.oldLeft = parseInt(dom.offsetLeft)
      this.drag.oldTop = parseInt(dom.offsetTop)
    },
    // 移动
    domMove(e) {
      if (this.drag.isDrag === true) {
        let dom = document.getElementById('shareBox')
        let maxW = parseInt(window.screen.availWidth - dom.offsetWidth)
        let maxH = parseInt(window.screen.availHeight - dom.offsetHeight)
        let left = parseInt(e.touches[0].clientX) - parseInt(dom.offsetWidth / 2)
        let top = parseInt(e.touches[0].clientY) - parseInt(dom.offsetHeight / 2)
        if (left < 20) left = 0
        if (top < 20) top = 0
        if (left > maxW - 20) left = maxW
        if (top > maxH - 20) top = maxH
        // dom.style.left = left + 'px'
        dom.style.top = top + 'px'
      }
    },
    // 松开
    domUp(e) {
      let dom = document.getElementById('shareBox')
      let close = document.getElementById('close')
      this.drag.newLeft = parseInt(dom.offsetLeft)
      this.drag.newTop = parseInt(dom.offsetTop)
      this.drag.isDrag = false
      // 只是点击
      if (Math.abs(this.drag.oldLeft - this.drag.newLeft) < 20 && Math.abs(this.drag.oldTop - this.drag.newTop) < 20) {
        if (e.target === close) {
          this.isShare = false
        } else {
          this.shareClick()
        }
      }
    },
    // 日期格式转换
    dateFormat(str) {
      str = str.split(' ')[0]
      str = str.replace(/-/g, '.')
      return str
    },
    // 语言格式转换
    langformat(str) {
      if (str === '' || str === null) return ''
      str = JSON.parse(str)
      if (this.lang === 'sc') {
        return str.zh_cn
      } else if (this.lang === 'tc') {
        return str.zh_tw
      } else {
        return str.en_us
      }
    },
    // 看今日
    lookToday() {
      logEventStatistics({umkey: 'Life_preferential2_backtoday'})
      this.tabCheck(this.today - 1)
    },
    // 分享赚积分
    shareClick() {
      logEventStatistics({umkey: 'Life_preferential2_share'})
      let title = this.$t('everyDaySpecial.shareTitle')
      let content = this.$t('everyDaySpecial.shareTitle')
      let url = `${window.location.origin}/activity/mylinkActivity/#/everyDaySpecial/index?hideNavigationBar=true`
      let img = require('../../../static/img/new_ml_logo_a@2x.png')
      if (!isApp()) {
        callApp(`${window.location.origin}/activity/mylinkActivity/#/everyDaySpecial/index?hideNavigationBar=true`)
        return;
      }
      if (this.authorization === '') {
        getUserNewInfo()
        return;
      }
      this.$http.getOther('/dayDiscount/activity/activity/integral/share').then(res => {
        if (res.data.code === 10000) {
          window.location.href = `cmcchkhsh://openshare?title=${title}&content=${content}&url=${url}&img=${img}`
        } else {
          this.errorTips(res.data.code)
        }
      }).catch(err => {
        window.location.href = `cmcchkhsh://openshare?title=${title}&content=${content}&url=${url}&img=${img}`
      })
    },
    // 预约按钮
    subscribe(type, id, item) {
      if (!isApp()) {
        callApp(`${this.URL}/activity/mylinkActivity/#/everyDaySpecial/index?hideNavigationBar=true`)
        return;
      }
      if (this.authorization === '') {
        getUserNewInfo()
        return;
      }
      // "预约来源：1：优惠券预约 2：场次预约  3：商品预约  4：活动预约"
      this.$http.postOther('/dayDiscount/coupon/pushNotification/subscribe', {
        itemId: id,
        link: `${this.URL}/activity/mylinkActivity/#/everyDaySpecial/index?hideNavigationBar=true&weekDay=${this.today}`,
        eventId: this.tabIndex + 1,
        type
      }).then(res => {
        if (res.data.code === 10000) {
          if (type === 2) {
            this.isMask = true
            setTimeout(() => {
              this.isMask = false
            }, 2500)
          } else {
            if (type === 3) item.subscribedNum += 1
            this.$toast({msg: this.$t('everyDaySpecial.index.t20'), time: 2000})
          }
        } else if (res.data.code === 10002) {
          this.$toast({msg: this.$t('everyDaySpecial.index.t21'), time: 2000})
        }
      }).catch(err => {
        this.errorTips()
      })
    },
    // 超时重新支付券
    async resetPay(item) {
      let kill = ''
      let path = ''
      // 获取抢券地址
      let pathData = await this.$http.getOther('/dayDiscount/seckill/secKillCoupon/killPath', {
        id: this.tabIndex + 1,
        couponId: item.couponId
      })
      if (pathData.data.code === 10000) {
        path = pathData.data.data
      } else {
        this.errorTips(pathData.data.code)
        this.isTouch = false
        return
      }
      // 抢券
      let killData = await this.$http.getOther('/dayDiscount/seckill/secKillCoupon/kill', {
        id: this.tabIndex + 1,
        couponId: item.couponId,
        path
      })
      if (killData.data.code === 10000) {
        kill = killData.data.data
      } else {
        this.errorTips(killData.data.code)
        this.isTouch = false
        return
      }
      let payData = await this.$http.getOther('/dayDiscount/seckill/secKillCoupon/pay', {
        id: this.tabIndex + 1,
        couponId: item.couponId,
        snapshotId: kill
      })
      console.log(payData)
      if (payData.data.code === 10000) {
        item.userKill = true
        item.couponRemainCount = item.couponRemainCount - 1
        item.payedSnapshotId = kill
        item.toPaySnapshotId = null
        this.$toast({msg: this.$t('everyDaySpecial.index.t26'), time: 2000})
      } else {
        item.toPaySnapshotId = null
        this.errorTips(payData.data.code)
      }
      this.isTouch = false

    },
    // 优惠券按钮
    async couponBtnClick(item) {
      logEventStatistics({umkey: 'Life_preferential2_Redeem'})
      if (!isApp()) {
        callApp(`${this.URL}/activity/mylinkActivity/#/everyDaySpecial/index?hideNavigationBar=true`)
        return;
      }
      if (this.authorization === '') {
        getUserNewInfo()
        return;
      }
      if (this.isTouch) return
      this.isTouch = true
      let kill = ''
      let path = ''
      if (item.toPaySnapshotId === null) {
        // 获取抢券地址
        let pathData = await this.$http.getOther('/dayDiscount/seckill/secKillCoupon/killPath', {
          id: this.tabIndex + 1,
          couponId: item.couponId
        })
        if (pathData.data.code === 10000) {
          path = pathData.data.data
        } else {
          this.errorTips(pathData.data.code)
          this.isTouch = false
          return
        }
        // 抢券
        let killData = await this.$http.getOther('/dayDiscount/seckill/secKillCoupon/kill', {
          id: this.tabIndex + 1,
          couponId: item.couponId,
          path
        })
        if (killData.data.code === 10000) {
          kill = killData.data.data
        } else {
          this.errorTips(killData.data.code)
          this.isTouch = false
          return
        }
      } else {
        kill = item.toPaySnapshotId
      }
      await this.$confirm({
        title: '',
        content: `${this.$t('everyDaySpecial.index.t22')}${item.couponCost}${this.$t('everyDaySpecial.index.t23')}${this.langformat(item.couponName)}`,
        buttonText: [
          {
            id: 'ok',
            text: this.$t('everyDaySpecial.index.t24')
          },
          {
            id: 'cancel',
            text: this.$t('everyDaySpecial.index.t25')
          },
        ]
      }).then(() => {
        // 确定扣减积分
        this.$http.getOther('/dayDiscount/seckill/secKillCoupon/pay', {
          id: this.tabIndex + 1,
          couponId: item.couponId,
          snapshotId: kill
        }).then(res => {
          if (res.data.code === 10000) {
            item.userKill = true
            item.couponRemainCount = item.couponRemainCount - 1
            item.payedSnapshotId = kill
            item.toPaySnapshotId = null
            this.$toast({msg: this.$t('everyDaySpecial.index.t26'), time: 2000})
          } else if (res.data.code === 14006) {
            item.toPaySnapshotId = null
            this.resetPay(item)
          } else {
            item.toPaySnapshotId = null
            this.errorTips(res.data.code)
          }
          this.isTouch = false
        }).catch(err => {
          this.isTouch = false
        })
      }).catch(() => {
        // 取消抢券
        this.$http.getOther('/dayDiscount/seckill/secKillCoupon/notPay', {
          id: this.tabIndex + 1,
          couponId: item.couponId,
          snapshotId: kill
        }).then(res => {
          if (res.data.code === 10000) {
            item.toPaySnapshotId = null
            this.$toast({msg: this.$t('everyDaySpecial.index.t25'), time: 2000})
          } else {
            item.toPaySnapshotId = null
            this.errorTips(res.data.code)
          }
          this.isTouch = false
        }).catch(err => {
          this.isTouch = false
        })
      })
    },
    // 优惠券跳转详情页
    couponJumpDetail(item) {
      if (!isApp()) {
        callApp(`${this.URL}/activity/mylinkActivity/#/everyDaySpecial/index?hideNavigationBar=true`)
        return;
      }
      if (this.authorization === '') {
        getUserNewInfo()
        return;
      }
      this.$router.push({
        path: '/everyDaySpecial/couponDetail',
        query: {
          id: item.payedSnapshotId
        }
      })
    },
    // 相似商品
    sameProdut(item) {
      if (!isApp()) {
        callApp(`${this.URL}/activity/mylinkActivity/#/everyDaySpecial/index?hideNavigationBar=true`)
        return;
      }
      if (this.authorization === '') {
        getUserNewInfo()
        return;
      }
      this.$http.getOther('/dayDiscount/product/product/H5/same', {
        productId: item.productId,
        id: this.tabIndex + 1
      }).then(res => {
        if (res.data.code === 10000) {
          window.location.href = res.data.data
        }
      })
    },
    // 商品跳转
    productJump(item) {
      logEventStatistics({
        umkey: 'Life_preferential2_buy',
        param: 'goodsId',
        value: item.productId,
      })
      if (!isApp()) {
        callApp(`${this.URL}/activity/mylinkActivity/#/everyDaySpecial/index?hideNavigationBar=true`)
        return;
      }
      if (this.authorization === '') {
        getUserNewInfo()
        return;
      }
      if (this.flag === 1 && item.source === 1) return;
      if (item.remainNum === 0) return;
      // 积分商城跳转
      if (item.source === 0) {
        let time = ''
        if (this.tabIndex + 1 !== this.today) time = `&curStartTime=${this.startTime}`
        let url = `${this.URL}/mylink`
        window.location.href = `${url}/#/integral/goodsDetail?goodsId=${item.jumpId}&close=2${time}`
      } else if (item.source === 1) {  // 第三方跳转
        if (this.langformat(item.jumpUrl).indexOf('needAuth=1') !== -1) {
          this.isToast = true
          this.isToastUrl = this.langformat(item.jumpUrl).replace('needAuth=1', '')
        } else {
          window.location.href = this.langformat(item.jumpUrl).replace('needAuth=1', '')
        }
      }
    },
    // 活动跳转
    activityJump(item) {
      logEventStatistics({umkey: 'Life_preferential2_upgrade'})
      if (!isApp()) {
        callApp(`${this.URL}/activity/mylinkActivity/#/everyDaySpecial/index?hideNavigationBar=true`)
        return;
      }
      if (this.authorization === '') {
        getUserNewInfo()
        return;
      }
      if (this.langformat(item.url).indexOf('needAuth=1') !== -1) {
        this.isToast = true
        this.isToastUrl = this.langformat(item.url).replace('needAuth=1', '')
      } else {
        window.location.href = this.langformat(item.url).replace('needAuth=1', '')
      }
    },
    // 数据归零
    clearData() {
      this.H = '00'
      this.M = '00'
      this.S = '00'
      clearInterval(this.timer)
      this.timer = null
      this.bannerList = []
      this.background = ''
      this.word = ''
      this.startTime = ''
      this.endTime = ''
      this.couponList = []
      this.userKillList = []
      this.recommendedList = []
      this.productTabIndex = 0
      this.isTips = true
      this.flag = null
      this.productTabBox = false
      this.productTag = []
      this.productList = []
      this.slowList = []
      this.activityList = []
    },
    // tab切换
    tabCheck(index) {
      if (this.isCheck) return
      this.isCheck = true
      this.tabIndex = index
      window.scrollTo(0, 0)
      /* tab切换时初始化数据 */
      this.clearData()
      this.tabCheckInit()
      if (this.today === index + 1) logEventStatistics({umkey: 'Life_preferential2_today'})
      if (this.today === index + 2) logEventStatistics({umkey: 'Life_preferential2_tomorrow'})
      if (index === 4) logEventStatistics({umkey: 'Life_preferential2_weekend'})
    },
    /* tab切换后数据初始化 */
    async tabCheckInit() {
      /* 倒计时初始化 */
      let countDownTimeRes = await this.$http.getOther('/dayDiscount/seckill/secKillCoupon/countDownTime', {id: this.tabIndex + 1})
      if (countDownTimeRes.data.code === 10000) {
        this.flag = countDownTimeRes.data.data.eventStatus
        this.startTime = countDownTimeRes.data.data.startTime
        this.endTime = countDownTimeRes.data.data.endTime
        if (this.flag !== 1) {
          let that = this

          function Time() {
            let curTimestamp = new Date().getTime()
            let timestamp = 0
            if (that.flag === 2) {
              timestamp = new Date((that.endTime.replace(/-/g, '/'))).getTime()
            } else if (that.flag === 3) {
              timestamp = new Date((that.startTime.replace(/-/g, '/'))).getTime()
            }
            let time = parseInt(((timestamp - curTimestamp) / 1000))
            let d = parseInt(time / 3600 / 24)
            let h = parseInt((time / 3600) % 24)
            let m = parseInt((time / 60) % 60) < 10 ? '0' + parseInt((time / 60) % 60) : parseInt((time / 60) % 60)
            let s = parseInt(time % 60) < 10 ? '0' + parseInt(time % 60) : parseInt(time % 60)
            that.H = (h + d * 24) < 10 ? '0' + (h + d * 24) : (h + d * 24)
            that.M = m
            that.S = s
            if (parseInt(time % 60) < 0) {
              that.flag = 1
              clearInterval(that.timer)
            }
          }

          Time()
          this.timer = setInterval(() => {
            Time()
          }, 1000)
        }
      }
      /* banner初始化 */
      let banner = await this.$http.getOther('/dayDiscount/seckill/dayEvent/list')
      if (banner.data.code === 10000) this.bannerList = banner.data.data
      if (this.bannerList !== '' && this.bannerList[this.tabIndex].banner !== '') {
        let bannerData = JSON.parse(this.bannerList[this.tabIndex].banner)
        this.lang === 'sc' ? this.background = bannerData.zh_cn : (this.lang === 'tc' ? this.background = bannerData.zh_tw : this.background = bannerData.en_us)
      }
      /* 预约初始化 */
      if (this.flag === 3) {
        let event = await this.$http.getOther('/dayDiscount/coupon/pushNotification/isSubscribe', {type: 2})
        if (event.data.code === 10000) {
          event.data.data.map((x, i) => {
            if (x == this.tabIndex + 1) this.isTips = false
          })
        }
      }
      let subscribeCouponList = []
      let subscribeActivityList = []
      let subscribeProductList = []
      let isKillCouponList = []
      if (this.tabIndex !== 4) {
        /* 优惠券预约 */
        let subscribeCoupon = await this.$http.getOther('/dayDiscount/coupon/pushNotification/isSubscribe', {type: 1})
        if (subscribeCoupon.data.code === 10000) subscribeCouponList = subscribeCoupon.data.data
        /* 活动预约 */
        let subscribeActivity = await this.$http.getOther('/dayDiscount/coupon/pushNotification/isSubscribe', {type: 4})
        if (subscribeActivity.data.code === 10000) subscribeActivityList = subscribeActivity.data.data
      }
      /* 优惠券初始化 */
      if (this.tabIndex !== 4) {
        let couponList = ''
        let coupon = await this.$http.getOther('/dayDiscount/coupon/coupon/H5/list', {id: this.tabIndex + 1})
        if (coupon.data.code === 10000) {
          couponList = coupon.data.data
          couponList.sort((m, n) => {
            let a = m['couponClassificationResVO']['sort'];
            let b = n['couponClassificationResVO']['sort'];
            return a - b
          })
        }
        /* 获取用户是否领取优惠券 */
        let isKillCoupon = []
        if (this.userId !== '') {
          isKillCoupon = await this.$http.getOther('/dayDiscount/seckill/secKillCoupon/userKillCouponStatus', {
            id: this.tabIndex + 1,
            userId: this.userId
          })
          if (isKillCoupon.data.code === 10000) isKillCouponList = isKillCoupon.data.data
        }
        couponList.map((X, I) => {
          X.couponH5ResVOS.sort((m, n) => {
            let a = m['sort']
            let b = n['sort']
            return a - b
          })
          X.couponH5ResVOS.map((x, i) => {
            x.userKill = false
            x.isSubscribe = false
            isKillCouponList.map((val, v) => {
              if (val.couponId === x.couponId) {
                x.userKill = val.payedSnapshotId === null ? false : true
                x.payedSnapshotId = val.payedSnapshotId
                x.toPaySnapshotId = val.toPaySnapshotId
              }
            })
            subscribeCouponList.map((val, v) => {
              if (val === x.couponId) x.isSubscribe = true
            })
          })
        })
        this.couponList = couponList

      }
      /* 活动初始化 */
      if (this.tabIndex !== 4) {
        let activity = await this.$http.getOther('/dayDiscount/activity/activity/H5/list', {id: this.tabIndex + 1})
        if (activity.data.code === 10000) {
          activity.data.data.sort((m, n) => {
            let a = m['activityClassificationResVO']['sort']
            let b = n['activityClassificationResVO']['sort']
            return a - b
          })
          activity.data.data.map(x => {
            x.activityH5ResVOS.sort((m, n) => {
              let a = m['sort']
              let b = n['sort']
              return a - b
            })
          })
          this.activityList = activity.data.data
        }
      }
      /* 商品初始化 */
      /* 手慢无 */
      if (this.tabIndex === 4) {
        let slow = await this.$http.getOther('/dayDiscount/product/product/H5/saleTop10', {id: this.tabIndex + 1})
      }
      /* 商品预约 */
      let productList = []
      let subscribeProduct = await this.$http.getOther('/dayDiscount/coupon/pushNotification/isSubscribe', {type: 3})
      if (subscribeProduct.data.code === 10000) subscribeProductList = subscribeProduct.data.data
      let product = await this.$http.getOther('/dayDiscount/product/product/H5/list', {id: this.tabIndex + 1})
      let sale = await this.$http.getOther('/dayDiscount/product/product/H5/saleUserActionInfo', {id: this.tabIndex + 1})
      if (product.data.code === 10000) {
        product.data.data.sort((m, n) => {
          let a = m['productClassificationResVO']['sort']
          let b = n['productClassificationResVO']['sort']
          return a - b
        })
        this.productTag = []
        product.data.data.map((x, i) => {
          x.productH5ResVOS.sort((m, n) => {
            let a = m['sort']
            let b = n['sort']
            return a - b
          })
          x.productH5ResVOS.map((X, I) => {
            if (sale.data.code === 10000) {
              sale.data.data.map((val, j) => {
                if (val.productId === X.productId) {
                  X.remainNum = val.remainNum
                  X.total = val.total
                  X.subscribedNum = val.subscribedNum
                }
              })
            }
            this.recommendedList.push(X)
          })
          this.productTag.push(x.productClassificationResVO)
        })
        this.recommendedList.sort((m, n) => {
          let a = m['sort']
          let b = n['sort']
          return a - b
        })
        this.productList = product.data.data
        if (this.recommendedList.length > 6) this.recommendedList = this.recommendedList.slice(0, 6)
      }
      this.isCheck = false
      this.initBScroll()
    },
    /*  better-scroll的初始化 */
    initBScroll() {
      this.$nextTick(() => {
        if (!this.scroll['scrollTab']) {
          this.scroll['scrollTab'] = new BScroll(this.$refs.scrollTab, {
            scrollY: false,
            scrollX: true,
            probeType: 3,
            click: true,
            mouseWheel: true
          });
        } else {
          this.scroll['scrollTab'].refresh()
        }
        if (!this.scroll['scrollContent']) {
          this.scroll['scrollContent'] = new BScroll(this.$refs.index, {
            scrollY: true,
            scrollX: false,
            probeType: 3,
            click: true,
            mouseWheel: true
          })
        } else {
          this.scroll['scrollContent'].refresh()
        }
        // 获取滚动的值，赋值给scrollY
        this.scroll['scrollContent'].on('scroll', pos => {
          this.scroll['scrollY'] = Math.abs(Math.round(pos.y))
          this.productTabShow()
        })
        this.scroll['scrollContent'].on("scrollEnd", pos => {
          //结束时触发事件获取一次位置，因为使用了模式2，惯性滚动不触发事件
          this.scroll['scrollY'] = Math.abs(Math.round(pos.y))
          this.productTabShow()
        })
        this.getHeight()
      })
    },
    /* 商品tab是否显示 */
    productTabShow() {
      if (this.tabIndex === 4) {
        let pageWidth = document.body.clientWidth
        if (this.scroll['scrollY'] > document.querySelector('#tabBox').offsetHeight - 0.093 * pageWidth) {
          toggleTopbar(1)
          switchNavColor({color: '333333'})
        } else {
          switchNavColor({color: 'FFFFFF'})
          toggleTopbar(0)
        }
        let fixedPx = document.querySelector('#content').offsetTop - document.querySelector('.productTab').offsetHeight - 0.117 * pageWidth
        this.scroll['isShow'] = this.scroll['scrollY'] > fixedPx
        if (this.scroll['scrollY'] > fixedPx) this.scroll['scrollContent'].refresh()
        let Index = this.scroll['list'].findIndex((item, index) => {
          return (
              this.scroll['scrollY'] >= this.scroll['list'][index] &&
              this.scroll['scrollY'] < this.scroll['list'][index + 1]
          )
        })
        this.scroll['scrollIndex'] = Index
      }
    },
    //获取列表每一个li的高度，存入数组中
    getHeight() {
      //获取每一个li的高度
      const lis = this.$refs.item;
      let height = 0;
      this.scroll['list'].push(height);
      //之后的高度即为当前li的高度加上之前面li的高度和
      lis.forEach(item => {
        //clientHeight = content + padding
        height += (item.clientHeight);
        this.scroll['list'].push(height);
      });
    },
    /* 商品tab切换 */
    productSelectTab(index) {
      const scrollTab = document.getElementById('productTab').clientHeight
      this.scroll['scrollIndex'] = index
      //点击左边菜单栏，立马高亮，不会等到右侧滚动结束后，左侧菜单栏才开始高亮（优化）
      this.scroll['scrollY'] = this.scroll['list'][index];
      let item = this.$refs.item;
      let el = item[index];
      let ios = system() === 'ios' ? -80 : 0
      this.scroll['scrollContent'].scrollToElement(el, 1000, 0, -scrollTab + ios);
    },
    /* 进入页面初始化并获取当前日期 */
    async Init() {
      if (!isApp()) {
        this.inApp = false
      } else {
        window.getUserInfo = (obj) => {
          if (obj) {
            this.authorization = obj.authorization
            setAuthorization(obj.authorization)
            setHeader({'X-USER-ID': obj.user.userId})
            this.userId = obj.user.userId
          }
        }
        getUserInfo({callbackName: 'getUserInfo', needLogin: false})
        if (this.phone === 'ios') {
          controlTopButton({
            right1icon: 'https://mylink.oss-accelerate.aliyuncs.com/5gact/icon_myticket.png',
            right1link: `openhkhshlogin://${window.location.origin}/activity/coupons/#/couponList?lang=${this.lang}&hideNavigationBar=true`,
            right2icon: 'https://mylink.oss-accelerate.aliyuncs.com/5gact/icon_list_mypoint.png',
            right2link: `${window.location.origin}/mylink/#/integral/points?hideNavigationBar=true`,
          })
        } else {
          // 客户端顶部右侧按钮
          controlTopButton({
            right1icon: 'https://mylink.oss-accelerate.aliyuncs.com/5gact/icon_list_mypoint.png',
            right1link: `${window.location.origin}/mylink/#/integral/points?hideNavigationBar=true`,
            right2icon: 'https://mylink.oss-accelerate.aliyuncs.com/5gact/icon_myticket.png',
            right2link: `openhkhshlogin://${window.location.origin}/activity/coupons/#/couponList?lang=${this.lang}&hideNavigationBar=true`,
          })
        }
        // 隐藏客户端状态栏
        toggleTopbar(0);
        // h5控制客户端导航栏字体颜色
        switchNavColor({color: 'FFFFFF'})
      }
      let that = this
      this.lang = window.localStorage.lang
      let date = await this.$http.getOther('/dayDiscount/seckill/secKillCoupon/countDownTime', {id: 1})
      if (date.data.code === 10000) {
        let data = date.data.data
        let serverNowTime = data.serverNowTime.replace(/\-/g, '/')
        let now = new Date(serverNowTime);
        let day = now.getDay() === 0 ? 7 : now.getDay()
        this.today = (day === 6 || day === 7 ? day = 5 : day)
        this.tabIndex = day - 1
        if (day === 5) this.tabIndex = 4
        if (this.$route.query.weekDay) {
          this.tabCheck(this.$route.query.weekDay - 1)
        } else {
          this.tabCheck(this.tabIndex)
        }
        // 页面进入统计
        this.pageCollect(1)
      }
    },
    /* 页面统计 */
    pageCollect(val) {
      let pageId = ''
      if (this.today === 1) pageId = 'Life_preferential2_Mon_page'
      if (this.today === 2) pageId = 'Life_preferential2_Tues_page'
      if (this.today === 3) pageId = 'Life_preferential2_wed_page'
      if (this.today === 4) pageId = 'Life_preferential2_Thur_page'
      if (this.today === 5) pageId = 'Life_preferential2_weekend_page'
      pageViewStatistics({
        pageId: pageId,
        start: val
      })
    },
  },
  destroyed() {
    clearInterval(this.timer)
    this.timer = null
    window.removeEventListener('scroll', this.handleScroll, true)
    document.removeEventListener('touchmove', this.domMove, false)
    this.pageCollect(0)
  },
  activated() {
    window.scrollTo(0, window.localStorage.scrollTop ? parseInt(localStorage.scrollTop) : 0);
  },
  mounted() {
    document.addEventListener('touchmove', this.domMove, false)
  },
  async created() {
    this.phone = system()
    this.Init()
  }
}



// WEBPACK FOOTER //
// ./src/page/everyDaySpecial/index.vue